<template>
  <div class="container-bg p-5">
    <!-- <hr /> -->
    <div class="row">
      <div class="col-12">
        <h3 class="text-uppercase">Abonnementen</h3>
      </div>
      <div class="col-12 mt-3">
        <div>
          <p
            @click="isEditMode = false"
            class="float-right"
            data-toggle="modal"
            data-target="#modalSubscription"
          >
            <i class="fa fa-plus" style="font-size: 24px;cursor: pointer"> </i>
          </p>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Abonnementen</th>
              <th>Bedrag</th>
              <th>Volgende betaaldatum</th>
              <th>Betaalmethoden</th>
              <th>Begindatum</th>
              <th>Einddatum</th>
              <th>Interval</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(subscription, index) in selected_subscription_items"
              :key="'choice' + index"
            >
              <td>
                <button
                  type="button"
                  class="text-danger mt-3 mr-2 btn btn-transparent px-1 reset-none"
                  @click="deleteChoice(index)"
                >
                  <i class="fas fa-trash"></i>
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#modalSubscription"
                  @click="setEditMode(index)"
                  class="text-default mt-3 mr-2 btn btn-transparent px-1 reset-none"
                >
                  <i class="fas fa-pen"></i>
                </button>
                <router-link
                  v-if="subscription.id"
                  :to="
                    `/profile/${user.id}/subscriptions/${subscription.ids}/payments`
                  "
                  class="text-default mt-3 mr-2 btn btn-transparent px-1 reset-none"
                >
                  <i class="fas fa-eye"></i>
                </router-link>
              </td>
              <td>
                {{ subscription.provider.name }} -
                {{ subscription.method.name }}
              </td>
              <td>
                <span v-if="subscription.subscription">
                  {{ subscription.subscription.amount_currency }}
                  {{ subscription.subscription.amount_value }}
                </span>
                <span v-else>
                  {{ subscription.manual_subscription_amount | priceFormat }}
                </span>
              </td>
              <td>
                {{ formatDate(subscription.next_date) }}
              </td>
              <td>
                <span v-if="subscription.subscription">
                  {{
                    subscription.subscription.discount == "1" ? "Korting" : ""
                  }}
                </span>
                <span v-else>
                  Handmatig
                </span>
              </td>
              <td>
                {{ formatDate(subscription.date_start) }}
              </td>
              <td>
                {{ formatDate(subscription.date_end) }}
              </td>
              <td>
                {{ subscription.interval }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12 float-right pr-md-5"
        v-if="selected_subscription_items.length"
      >
        <button
          class="btn btn-dark text-white float-right"
          @click="addSubscription"
        >
          Opslaan
        </button>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12">
        <h3 class="text-uppercase">Lopende Abonnementen</h3>
      </div>

      <div class="col-12 mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Hoofdabonnement</th>
              <th>Bedrag</th>
              <th>Volgende betaaldatum</th>
              <th>Laatste betalingsdatum</th>
              <th>Abonnementen</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(subscription, index) in current_subscription_items"
              :key="index"
            >
              <td>
                <span v-if="subscription.is_manual == 0">
                  {{ subscription.interval }} Payment |
                  {{ formatDate(subscription.date_start) }} -
                  {{ formatDate(subscription.date_end) }}
                </span>
                <span v-else> Handmatig </span>
              </td>

              <td>{{ subscription.amount_value | priceFormat }}</td>
              <td>
                {{ formatDate(subscription.next_payment_date) }}
              </td>
              <td>
                {{
                  subscription.last_payment
                    ? formatDate(subscription.last_payment.payment_date)
                    : ""
                }}
              </td>
              <td>
                <table class="table">
                  <tbody>
                    <tr
                      v-for="(row, ind) in subscription.user_subscription_rows"
                      :key="'row' + ind"
                    >
                      <td>
                        {{
                          row.subscription
                            ? row.subscription.title
                            : row.manual_payment_descrition
                        }}
                      </td>
                      <td>
                        {{
                          (row.subscription
                            ? row.subscription.discount
                              ? row.subscription.amount_value * -1
                              : row.subscription.amount_value
                            : row.manual_payment_amount) | priceFormat
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <a
                  v-if="canTestWebhook(subscription) == true"
                  href="javascript:void(0)"
                  class=" mt-3 mr-2"
                  @click="testWebhook(subscription.id)"
                  ><i class="fas fa-money-bill" title="Test webhook"></i>
                </a>
                <a
                  v-if="
                    subscription.last_payment == null &&
                      subscription.is_manual &&
                      userHasPermissions(['Financieel'])
                  "
                  href="javascript:void(0)"
                  class=" mt-3 mr-2"
                  @click="markAsPaid(subscription.id)"
                  ><i class="fas fa-money-bill" title="Mark as paid"></i>
                </a>
                <a
                  v-if="!subscription.is_ended"
                  href="javascript:void(0)"
                  class="text-danger mt-3 mr-2"
                  @click="cancelSubscription(subscription.id)"
                  ><i class="fas fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--subscription modal start-->
    <div
      class="modal fade"
      id="modalSubscription"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog " role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              @click="closeModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="!subscription_item.loading">
              <div class="col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase" v-if="isEditMode">
                      Abonnement Beheren
                    </h5>
                    <h5 class="text-uppercase" v-else>Nieuw Abonnement</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">Betaalprovider:</label>
                      <Multiselect
                        searchable
                        mode="single"
                        v-model="subscription_item.provider_id"
                        :options="
                          payment_providers.map((c) => {
                            return { value: c.id, label: c.name };
                          })
                        "
                      />
                      <small class="text-danger">
                        {{ subscription_item_errors.provider }}
                      </small>
                    </div>
                  </div>

                  <div class="col-md-12" v-if="subscription_item.provider_id">
                    <div class="form-group">
                      <label for="">Betaalmethode:</label>
                      <Multiselect
                        searchable
                        mode="single"
                        class="search: 'multiselect-search'"
                        :options="
                          filtered_payment_methods.map((d) => {
                            return { value: d.id, label: d.name };
                          })
                        "
                        v-model="subscription_item.method_id"
                        id=""
                      />

                      <small class="text-danger">
                        {{ subscription_item_errors.method }}
                      </small>
                    </div>
                  </div>

                  <!-- For manual -->
                  <div class="col-md-12" v-if="subscription_item.is_manual">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="name">Omschrijving:</label>
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="
                              subscription_item.manual_subscription_title
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <label for="name">Prijs:</label>
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"
                              >€</span
                            >
                          </div>
                          <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="
                              subscription_item.manual_subscription_amount
                            "
                            aria-describedby="basic-addon1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End manual -->

                  <div
                    class="col-md-12"
                    v-if="subscription_item.provider_id != null"
                  >
                    <div class="form-group">
                      <label for="name">Begindatum:</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="subscription_item.date_start"
                        aria-describedby="basic-addon1"
                      />
                      <small class="text-danger">
                        {{ subscription_item_errors.date_start }}
                      </small>
                    </div>
                  </div>

                  <div class="col-md-12" v-if="subscription_item.date_start">
                    <div class="form-group">
                      <label for="">Interval:</label>
                      <Multiselect
                        searchable
                        mode="single"
                        v-model="subscription_item.interval"
                        :options="
                          intervals.map((d) => {
                            return { value: d.value, label: d.text };
                          })
                        "
                      />
                      <small class="text-danger">
                        {{ subscription_item_errors.interval }}
                      </small>
                    </div>
                  </div>
                  <!-- Test -->
                  <div class="col-md-12" v-if="subscription_item.interval">
                    <div class="form-group">
                      <label for="">Eind datum:</label>
                      <Multiselect
                        searchable
                        mode="single"
                        v-model="subscription_item.date_end"
                        :options="
                          date_end_intervals.map((d) => {
                            return { value: d.value, label: d.text };
                          })
                        "
                      />
                      <small class="text-danger">
                        {{ subscription_item_errors.date_end }}
                      </small>
                    </div>
                  </div>

                  <div
                    class="col-md-12"
                    v-if="
                      !subscription_item.is_manual &&
                        subscription_item.provider_id != null
                    "
                  >
                    <div class="form-group">
                      <label for="name">Abonnement:</label>
                      <Multiselect
                        searchable
                        mode="single"
                        v-model="subscription_item.subscription_id"
                        :options="
                          filtered_subscriptions.map((d) => {
                            return { value: d.id, label: d.title };
                          })
                        "
                        :settings="{ width: '200px' }"
                      />

                      <small class="text-danger">
                        {{ subscription_item_errors.subscription }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 float-right pr-md-5">
                <div class="row">
                  <div class="col-md-12 mt-3">
                    <button
                      class="btn btn-dark text-white float-right"
                      v-if="subscription_item.id"
                      @click="storeSubscription()"
                    >
                      Opslaan
                    </button>
                    <button
                      class="btn btn-dark text-white float-right"
                      v-else
                      @click="chooseSubscription"
                    >
                      Aanmaken
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12 mb-3">
                <h5 class="text-uppercase">Aan het laden</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- subscription modal end-->
  </div>
</template>

<script>
import mixins from "../../../mixins/index";
import moment from "moment";

export default {
  name: "subscriptions",
  mixins: [mixins],
  data() {
    return {
      isEditMode: false,
      subscription_item_index: null,
      subscription_item: {
        provider_id: null,
        method_id: null,
        date_start: null,
        interval: null,
        date_end: null,
        subscription_id: null,
        manual_subscription_title: null,
        manual_subscription_amount: null,
        is_manual: false,
      },
      subscription_item_errors: {
        provider: null,
        method: null,
        date_start: null,
        interval: null,
        date_end: null,
        subscription: null,
      },
      loading: false,
      selected_subscription_items: [],
      current_subscription_items: [],
      subscriptions: [],
      payment_providers: [],
      payment_methods: [],
      filtered_payment_methods: [],
      filtered_subscriptions: [],
      intervals: [
        {
          value: "1 month",
          text: "Maand",
        },
        {
          value: "3 months",
          text: "Kwartaal",
        },
        {
          value: "1 year",
          text: "Jaar",
        },
      ],
      date_end_intervals: [],
    };
  },
  computed: {
    selected_provider() {
      return this.subscription_item.provider_id;
    },
    selected_interval() {
      return this.subscription_item.interval;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    selected_provider(val) {
      if (val != null) {
        this.filtered_payment_methods = this.payment_methods.filter((m) => {
          return m.payment_provider_id == this.subscription_item.provider_id;
        });

        let provider = this.payment_providers.find(
          (prov) => prov.id == this.subscription_item.provider_id
        );
        this.subscription_item.is_manual = provider.name != "Mollie";
      } else {
        this.filtered_payment_methods = [];
      }
    },
    selected_interval(val) {
      if (val != null) {
        this.subscription_item.date_end = null;
        this.filtered_subscriptions = [];
        let start = moment(this.subscription_item.date_start);
        let interval = this.subscription_item.interval;
        let [end_loop, multiple, step] = this.intervalStep(interval);
        let dates = [];
        for (let i = 0; i < end_loop; i++) {
          let value = start.add(multiple, step);
          dates.push({
            value: value.format("Y-MM-DD"),
            text: value.format("DD-MM-Y"),
          });
        }

        this.filtered_subscriptions = this.subscriptions.filter((sub) => {
          return sub.interval == interval;
        });

        this.date_end_intervals = dates;
      } else {
        this.filtered_subscriptions = [];
        this.date_end_intervals = [];
      }
    },
  },
  filters: {
    priceFormat: function(value) {
      let i = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
      }).format(value);
      return i;
    },
  },
  methods: {
    intervalStep(interval) {
      if (interval == "1 month") return [60, 1, "M"];
      if (interval == "3 months") return [20, 3, "M"];
      if (interval == "1 year") return [5, 1, "Y"];
    },
    chooseSubscription() {
      if (!this.validateSubscriptionItem()) return false;

      let provider = this.payment_providers.find(
        (provider) => provider.id == this.subscription_item.provider_id
      );
      let method = this.payment_methods.find(
        (method) => method.id == this.subscription_item.method_id
      );
      let interval = this.intervals.find(
        (inter) => inter.value == this.subscription_item.interval
      );
      let subscription = this.subscriptions.find(
        (sub) => sub.id == this.subscription_item.subscription_id
      );
      let date_config =
        this.subscription_item.interval != null
          ? this.intervalStep(this.subscription_item.interval)
          : null;
      let selected_start_date = this.subscription_item.date_start;
      let next_date =
        selected_start_date != null
          ? moment(selected_start_date).add(date_config[1], date_config[2])
          : null;

      this.selected_subscription_items.push({
        provider: provider,
        method: method,
        interval: interval != null ? interval.value : null,
        subscription: subscription,
        date_start: this.subscription_item.date_start,
        date_end: this.subscription_item.date_end,
        next_date: next_date,
        manual_subscription_title: this.subscription_item
          .manual_subscription_title,
        manual_subscription_amount: this.subscription_item
          .manual_subscription_amount,
        is_manual: this.subscription_item.is_manual,
      });

      window.$("#modalSubscription").modal("hide");

      this.subscription_item = {
        provider_id: null,
        method_id: null,
        date_start: null,
        interval: null,
        date_end: null,
        subscription_id: null,
        is_manual: false,
        manual_subscription_title: null,
        manual_subscription_amount: null,
      };
    },

    editSubscription() {
      this.selected_subscription_items.splice(
        this.subscription_item_index,
        1,
        this.subscription_item
      );

      window.$("#modalSubscription").modal("hide");

      this.subscription_item = {
        provider_id: null,
        method_id: null,
        date_start: null,
        interval: null,
        date_end: null,
        subscription_id: null,
        is_manual: false,
        manual_subscription_title: null,
        manual_subscription_amount: null,
      };
    },

    addSubscription() {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/users/add/subscription",
          details: {
            subscription: this.selected_subscription_items,
            user_id: this.$route.params.id,
          },
        })
        .then((data) => {
          if (
            Object.prototype.hasOwnProperty.call(data.data, "firstPaymentEmail")
          ) {
            this.$store.dispatch(
              "auth/makeNotification",
              {
                status: "Authorisatie",
                statusText:
                  "De eerste betalingsemail voor de automatische incasso is verzonden.",
              },
              5000
            );
          } else if (
            Object.prototype.hasOwnProperty.call(
              data.data,
              "firstPaymentEmailReminder"
            )
          ) {
            this.$store.dispatch(
              "auth/makeNotification",
              {
                status: "Authorisatie",
                statusText:
                  "De eerste betalingsemail voor de automatische incasso is verzonden.",
              },
              5000
            );
          } else {
            window.location.reload();
          }
        });
    },

    markAsPaid(id) {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/user/mark-subscription-as-paid",
          details: {
            sub_id: id,
            user_id: this.$route.params.id,
          },
        })
        .then(() => {
          window.location.reload();
        });
    },

    cancelSubscription(id) {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/user/cancel-subscription",
          details: {
            sub_id: id,
            user_id: this.$route.params.id,
          },
        })
        .then(() => {
          window.location.reload();
        });
    },

    deleteChoice(index) {
      this.$swal({
        title: "Weet je zeker dat je dit abonnement wilt verwijderen?",
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: `Nee`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.selected_subscription_items.splice(index, 1);
        }
      });
    },

    validateSubscriptionItem() {
      let is_valid = true;
      if (this.subscription_item.provider_id == null) {
        this.subscription_item_errors.provider = "Required";
        is_valid = false;
      }

      if (this.subscription_item.method_id == null) {
        this.subscription_item_errors.method = "Required";
        is_valid = false;
      }

      let provider = this.payment_providers.find(
        (provider) => provider.id == this.subscription_item.provider_id
      );

      if (
        this.subscription_item.interval == null &&
        provider.name == "Mollie"
      ) {
        this.subscription_item_errors.interval = "Required";
        is_valid = false;
      }

      if (
        this.subscription_item.date_start == null &&
        provider.name == "Mollie"
      ) {
        this.subscription_item_errors.date_start = "Required";
        is_valid = false;
      }

      /* if(this.subscription_item.date_end == null) {
                    this.subscription_item_errors.date_end = 'Required';
                    is_valid = false;
                } */

      if (
        this.subscription_item.subscription_id == null &&
        provider.name == "Mollie"
      ) {
        this.subscription_item_errors.subscription = "Required";
        is_valid = false;
      }

      if (
        this.subscription_item.manual_subscription_title == null &&
        provider.name != "Mollie"
      ) {
        this.subscription_item_errors.manual_subscription_title = "Required";
        is_valid = false;
      }

      if (
        this.subscription_item.manual_subscription_amount == null &&
        provider.name != "Mollie"
      ) {
        this.subscription_item_errors.manual_subscription_amount = "Required";
        is_valid = false;
      }

      return is_valid;
    },

    canTestWebhook(subscription) {
      console.log(process.env.VUE_APP_DEMO_ENV == 1);
      return (
        subscription.last_payment != null &&
        subscription.can_test_webhook &&
        this.userHasPermissions(["Financieel"]) &&
        process.env.VUE_APP_DEMO_ENV == 1
      );
    },

    testWebhook(id) {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/mollie/test-webhook",
          details: {
            user_subscription_id: id,
            user_id: this.$route.params.id,
          },
        })
        .then(() => {
          window.location.reload();
        });
    },

    setEditMode(index) {
      this.isEditMode = true;
      this.subscription_item_index = index;

      const subscription_data = this.selected_subscription_items[index];
      this.subscription_item = { ...subscription_data };

      this.subscription_item.provider_id = subscription_data.provider.id;
      this.subscription_item.method_id = subscription_data.method.id;
      this.subscription_item.subscription_id =
        subscription_data.subscription.id;
    },

    closeModal() {
      this.isEditMode = false;
      this.subscription_item = {
        provider_id: null,
        method_id: null,
        date_start: null,
        interval: null,
        date_end: null,
        subscription_id: null,
        manual_subscription_title: null,
        manual_subscription_amount: null,
        is_manual: false,
      };
    },
  },
  created() {
    this.$store
      .dispatch("get", "api/v1/subscriptions")
      .then((data) => {
        this.subscriptions = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/payment-providers")
      .then((data) => {
        this.payment_providers = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/payment-methods")
      .then((data) => {
        this.payment_methods = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/user-subscriptions/" + this.$route.params.id)
      .then((data) => {
        this.current_subscription_items = data.data.subscriptions;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.reset-none {
  outline: none !important;
  box-shadow: none !important;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .discount-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}

.table td,
.table th {
  vertical-align: middle !important;
}
.table {
  margin-bottom: 0px !important;
}
</style>
